module.exports = __webpack_public_path__ + "mk.svg?9830033dcb4da66ef8369a26c8fd27ad";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mk.svg
// module id = 1319
// module chunks = 27